import { RootState } from '@/store';

export const offerSelector = (state: RootState) => {
  return state.offerStore.offer;
};
export const offerListSelector = (state: RootState) => {
  return state.offerStore.offerList;
};
